<template lang="pug">
section.homeAbout
  
  #about.homeAbout-titlebox
    h2 Ian Hurdle <br/> top agent in the <br/>Turks and Caicos
    
  //- .homeAbout-logobox: img.svg-luxury(alt, src='@/assets/images/luxury.png')
  .homeAbout-descrbox
    h2 Ian Hurdle <br/> top agent in the <br/>Turks and Caicos
    p.
      One of the top agents serving the Caribbean's luxury markets,
      <b> Ian hurdle brings more than 30 years of experience</b>
      in the real estate, construction, property management, and hospitality industries to his role as Founder and Director of The Agency Caribbean.
    p.
      The Agency is a full-service, luxury real estate brokerage and lifestyle company representing clients worldwide in a broad spectrum of classes, including residential, new development, resort real estate, residential leasing and luxury vacation rentals.
  .homeAbout-photobox

    img.homeAbout-photo(alt, src='@/assets/images/ian.jpg')
  .homeAbout-infobox
    .homeAbout-info 
      .info-text $500M+
      .info-desc sales volume in 2025
    .homeAbout-info
      .info-text $1B+
      .info-desc total sales volume 
    .homeAbout-info
      .info-text 50+
      .info-desc sales over 10M
    .homeAbout-info 
      .info-text 100+
      .info-desc sales over 2M
</template>

<script>
  export default {
    components: {
      SvgComponent: () => import('@/components/SvgComponent'),
      // DrawLine: () => import('@/components/DrawLine'),
    },
  };
</script>

<style lang="scss">
  .homeAbout {
    display: contents;
    &-titlebox {
      padding-top: 64px;
      padding-bottom: 16px;

      h2{
        font-family: 'Abhaya Libre';
        font-weight: 800;
        
        text-align: left;
      }
      
      @include tablet {
        /* padding-top: 56px;
        padding-bottom: 32px;
        text-align: center; */
      }
      @include phone {
        h2 {
          font-size: 42px;
          /* line-height: 29px; */
        }
      }
    }
    &-logobox {
      padding-top: 150px;
      padding-bottom: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      @include tablet {
        padding-top: 20px;
        padding-bottom: 20px;
        .svg-luxury {
          transform-origin: center;
          transform: scale(0.8);
        }
      }
    }
    &-descrbox {
      h2 {
      font-size: 72px;
      line-height: 72px;  
      font-family: "Abhaya Libre";
      font-weight: 800;
      color: #1F1E1E;
      }
     
      font-size: 18px;
      line-height: 32px;
      padding-top: 130px;
      display: flex;
      flex-direction: column;
      padding-right: 50px;
      @include gap(30px, col);
       p {
        margin-top: 30px;
      }

      @include large {
        @include gap(30px, col);
      }
      @include middle {
        padding-top: 60px;
        font-size: 18px;
        padding-right: 60px;
      }

      @include tablet {
        padding-top: 40px;
        @include gap(16px, col);
        padding-right: 20px;
        padding-bottom: 60px;
        h2 {
          font-size: 50px;
          line-height: 50px;
        }


        br {
          /* display: none; */
        }
      }
      @include phone {
        padding-bottom: 25px;
        padding-top: 25px;
        padding-right: 0px;
        h2 {
          font-size: 24px;
          line-height: 29px;
          display:none;
        }
      }

      p {
        @include tablet {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
    &-photobox {
      height: 750px;
      margin-bottom: 120px;
      margin-top: 42px;
      img{
        width: 100%;
        height: 100%;
        
      }
      @include middle {
        /* height: 480px; */
        margin-bottom: 180px;
      }

      @include small {
        height: auto;
        margin-bottom: 120px;
      }
      @include tablet {
        margin-top: 40px;
        height: auto;
        margin: 40px 0;
       
      }
      @include phone {

        height: 100vw;
        margin-bottom: 0px;
        margin-top: 0;
      }
    }
    &-photo {
      width: 100%;
      height: 100%;
      object-fit: cover;
      @include phone {
         /* top: 0; */
      }
    }

    &-infobox{
      display: flex;
      justify-content: space-between;
      margin-bottom: 120px;

      @include tablet {
        
         
         .homeAbout-info{
         .info-text {
            font-size: 60px;
          }
         }
         
        
      }

      @include phone {
        flex-direction: column;
        margin-bottom: 32px;
        gap: 32px;
       }
      
    }
    &-info{
      font-family: "Abhaya Libre";
      .info-text{
        font-size: 100px;
        font-weight: 500;
        color: #1F1E1E;
      }
      .info-desc{
        font-size: 18px;
        font-weight: 800;
        color: #D41E34
      }

      @include phone {
        text-align: center;


        &:first-of-type{
          order: 2;
          
        }

        &:nth-of-type(2){
          order: 1;
        }

        &:nth-of-type(3){
          order: 4;
        }

        &:last-of-type{
          order: 3
        }
        .info-text{
          font-size: 60px;
          line-height: 60px;
        }
        .info-desc{
          font-size: 16px;
          line-height: 20px;
          margin-top: 6px;

          @include phone {
            font-family: "Proxima Nova";
            font-weight: 400;
          }
        }
       }
      
    }
  }
</style>
